import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Lgpd: React.FC = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <main className="max-w-4xl mx-auto py-32 px-4">
      <h1 className="text-3xl font-bold text-center mb-8">Política de Privacidade (LGPD)</h1>
      
      <div className="text-gray-700 space-y-6">
        <p className="mb-4">Esta página descreve nossa política de privacidade em conformidade com a Lei Geral de Proteção de Dados (LGPD).</p>
        <p className="mb-2">Empresa: <strong>Onmai Innovations</strong></p>
        <p className="mb-2">CNPJ: <strong>12.920.067/0001-23</strong></p>
        <p className="mb-6">E-mail de contato: <a href="mailto:contato@onmai.com.br" className="text-blue-600 underline">contato@onmai.com.br</a></p>
        
        <h2 className="text-xl font-semibold mt-8 mb-2">1. O que é a LGPD?</h2>
        <p>A Lei Geral de Proteção de Dados (Lei nº 13.709/2018) regula o tratamento de dados pessoais no Brasil, garantindo direitos aos titulares e impondo deveres às empresas.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-2">2. Quais dados coletamos?</h2>
        <ul className="list-disc ml-6 space-y-1">
          <li>Nome, e-mail e telefone para contato e suporte.</li>
          <li>Dados de navegação, como endereço IP, cookies e logs de acesso.</li>
          <li>Informações fornecidas voluntariamente pelo usuário em formulários.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mt-8 mb-2">3. Como usamos os dados?</h2>
        <ul className="list-disc ml-6 space-y-1">
          <li>Para prestar e aprimorar nossos serviços.</li>
          <li>Para comunicação institucional e suporte ao cliente.</li>
          <li>Para cumprir obrigações legais e regulatórias.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mt-8 mb-2">4. Direitos do titular</h2>
        <ul className="list-disc ml-6 space-y-1">
          <li>Confirmação da existência de tratamento.</li>
          <li>Acesso, correção e exclusão de dados.</li>
          <li>Portabilidade e revogação do consentimento.</li>
          <li>Informação sobre compartilhamento de dados.</li>
        </ul>
        
        <h2 className="text-xl font-semibold mt-8 mb-2">5. Segurança</h2>
        <p>Adotamos medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados, vazamentos e incidentes de segurança.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-2">6. Contato</h2>
        <p>Para exercer seus direitos ou tirar dúvidas sobre privacidade, entre em contato pelo e-mail <a href="mailto:contato@onmai.com.br" className="text-blue-600 underline">contato@onmai.com.br</a>.</p>
      </div>
    </main>
    <Footer />
  </div>
);

export default Lgpd; 
